import { deleteReq } from "../../service/api";

const deleteFunctionCall = async (id) => {
  try {
    const response = await deleteReq(`/ai/functionCalls/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleteFunctionCall:", error);
    throw error;
  }
};

export default deleteFunctionCall;
